import { useClassroomPolicyStore } from "@/stores/v2/classroomPolicyStore";
import { EditingFocus } from "@/components/FocusLibraryDrawer/FocusPage";

export function togglePauseForStudentInState(student: string): void {
	const paused: string[] = useClassroomPolicyStore.getState().getPausedStudents();

	if (paused.includes(student)) {
		useClassroomPolicyStore.getState().setPausedStudents(paused.filter((user: string) => user !== student));
	} else {
		useClassroomPolicyStore.getState().setPausedStudents([...paused, student]);
	}
}

export function getFocusedStudentIdsFromAppliedFocuses(appliedFocuses: EditingFocus[]): string[] {
	return appliedFocuses.reduce((acc: string[], focus: EditingFocus) => {
		return [...acc, ...focus.studentIds];
	}, []);
}
